
import { defineComponent, PropType } from 'vue'
import { PULL_REQUEST_STATUS } from '~/types/autofix'
import { Maybe, Scalars } from '~/types/types'

export default defineComponent({
  name: 'AutofixCodeDiff',

  props: {
    isGroup: {
      type: Boolean
    },
    changeSet: {
      type: Object as PropType<Maybe<Scalars['GenericScalar']>>,
      required: true
    },
    selectedFiles: {
      type: Array as PropType<Array<string>>,
      default: () => []
    },
    isReadOnly: {
      type: Boolean,
      required: true
    },
    selectedHunkIds: {
      type: Array as PropType<Array<number>>,
      required: true
    },
    isGeneratedFromPr: {
      type: Boolean,
      required: true
    },
    snippetsLoading: {
      type: Boolean,
      default: false
    },
    snippetsFetchErrored: {
      type: Boolean,
      default: false
    },
    pullRequestStatus: {
      type: String,
      default: PULL_REQUEST_STATUS.CREATED
    }
  },

  data() {
    return {
      isChecked: false,
      PULL_REQUEST_STATUS
    }
  },

  methods: {
    /**
     * Emits an event by the name `selectFile` passing in the `file` name
     *
     * @param {string} file
     * @returns {void}
     */
    selectFile(file: string): void {
      this.$emit('selectFile', file)
    },

    /**
     * Returns the status about whether a hunk id is in the list of selected ids
     *
     * @param {number} id
     * @returns {void}
     */
    isHunkSelected(id: number): boolean {
      return this.selectedHunkIds.includes(id)
    },

    /**
     * Emits an event by the name `selectFileIfAllHunksSelected` passing in the `file` name and `id`
     *
     * @param {string} file
     * @param {number} id
     * @returns {void}
     */
    selectFileIfAllHunksSelected(file: string, id: number): void {
      this.$emit('selectFileIfAllHunksSelected', file, id)
    }
  }
})
